import script from "./MonarchConnect.vue?vue&type=script&setup=true&lang=js"
export * from "./MonarchConnect.vue?vue&type=script&setup=true&lang=js"

import "./MonarchConnect.vue?vue&type=style&index=0&id=6491d73b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6491d73b"]])

export default __exports__